import * as Sentry from '@sentry/react';
import { sum } from 'lodash';
import { z } from 'zod';

import { safeMax } from './iteration';

export const durationCalculationMethodSchema = z.union([z.literal('SUM'), z.literal('MAX')]);
export type DurationCalculationMethod = z.infer<typeof durationCalculationMethodSchema>;

export const safeDurationCalculationMethod = (
    durationCalculationMethod: DurationCalculationMethod | undefined,
): DurationCalculationMethod => {
    if (durationCalculationMethod === undefined) {
        Sentry.captureException(new Error(`Duration calculation method was undefined.`));
        return 'SUM';
    } else {
        return durationCalculationMethod;
    }
};

export const computedDurationFromServices = (
    services: { duration_minutes: number }[],
    durationCalculationMethod: DurationCalculationMethod | undefined,
): number => {
    const durations = services.map((service) => service.duration_minutes);
    switch (safeDurationCalculationMethod(durationCalculationMethod)) {
        case 'MAX':
            return safeMax(durations, 0);
        case 'SUM':
            return sum(durations);
    }
};
